<template>
  <sui-modal class="wrapper" size="small" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update member
    </sui-modal-header>
    <sui-modal-content scrolling>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormMember v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button class="left floated basic red" icon="trash" label-position="left" :disabled="!access.accManagement" @click="deleteMember()">
        Delete
      </sui-button>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors || !hasChanges || !access.accManagement" data-goal="UPDATE_MEMBER_TRY" @click="submit()">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import ModalForm from '@/mixins/ModalForm'
  import FormMember from '@/components/forms/Member'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateMember',
    mixins: [
      ModalForm,
    ],
    components: {
      FormMember,
    },
    data() {
      return {
        accountId: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'account']),
      mode() {
        return 'updating'
      },
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal('UPDATE_MEMBER_SUCCESS')
      },
      onFail() {
        utils.reachGoal('UPDATE_MEMBER_FAIL')
      },
      deleteMember() {
        return this.$modals.confirm.open({
          text: `<p>You are going to delete <b>${this.entity.name}</b> member.</p>`,
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('UPDATE_MEMBER_DELETE_TRY')
            this.entity.delete().then(() => {
              utils.reachGoal('UPDATE_MEMBER_DELETE_SUCCESS')
              this.close()
            }).catch(error => {
              utils.reachGoal('UPDATE_MEMBER_DELETE_FAIL')
              this.apiErrors = error
            })
          },
        })
      },
    },
    created() {
      this.$modals.updateMember = this
    },
  }
</script>
